import { render, staticRenderFns } from "./activityResource.vue?vue&type=template&id=9114a23c&"
import script from "./activityResource.vue?vue&type=script&lang=js&"
export * from "./activityResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports